import Vue from 'vue';
import Router from 'vue-router';

// Login y Home
import Login from '@/pages/Login/Login';
import Home from '@/pages/Home/Home';
import MySignals from '@/pages/MySignals/MySignals';
import SignalDetail from '@/pages/SignalDetail/SignalDetail';
import ActiveSignals from '@/pages/ActiveSignals/ActiveSignals';
import PotentialSignals from '@/pages/PotentialSignals/PotentialSignals';
import ClosedSignals from '@/pages/ClosedSignals/ClosedSignals';
import TrackRecord from '@/pages/TrackRecord/TrackRecord';
import Dashboard from '@/pages/Statistics/Statistics';
import MarketSentiment from '@/pages/MarketSentiment/MarketSentiment';

// Pantalla de error por defecto cuando no existe una ruta
import Layout from '@/components/Layout/Layout';
import Error from '@/pages/Error/Error';

import { isAuthenticated } from './mixins/auth';

Vue.use(Router);

export default new Router({
  routes: [
    { path: '/', redirect: { name: 'Dashboard' } },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/',
      name: 'Layout',
      component: Layout,
      redirect: { name: 'Layout' },
      beforeEnter: (to, from, next) => {
        isAuthenticated() ? next() : next({ path: '/login' });
      },
      children: [
        // Pantallas principales del proyecto
        // Es necesario estar autenticado para tener acceso a ellas
        {
          path: 'home',
          name: 'Home',
          component: Home,
        },
        {
          path: 'mySignals',
          name: 'MySignals',
          component: MySignals,
        },
        {
          path: 'signaldetail',
          name: 'SignalDetail',
          component: SignalDetail,
          props: true,
        },
        {
          path: 'activeSignals',
          name: 'ActiveSignals',
          component: ActiveSignals,
          props: true,
        },
        {
          path: 'potentialSignals',
          name: 'PotentialSignals',
          component: PotentialSignals,
        },
        {
          path: 'closedSignals',
          name: 'ClosedSignals',
          component: ClosedSignals,
        },
        {
          path: 'trackRecord',
          name: 'TrackRecord',
          component: TrackRecord,
        },
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
        },
        {
          path: 'marketSentiment',
          name: 'MarketSentiment',
          component: MarketSentiment,
        },
      ],
    },
    {
      path: '*',
      name: 'Error',
      component: Error,
    },
  ],
  scrollBehavior() {
      return { x: 0, y: 0 };
  },
});
